import { NgModule } from '@angular/core';

import { AddLineComponent } from './add-line.component';

/**
 *  @deprecated use AddLineComponent
 */
@NgModule({
  imports: [AddLineComponent],
  exports: [AddLineComponent],
})
export class AddLineModule {}
export { AddLineComponent } from './add-line.component';
